import { useEffect, useState } from 'react';

import { navigatorIsAvailable } from '../utils';

let os: 'Windows' | 'Macintosh' | 'Other' | '';

const getOperatingSystem = (): typeof os => {
  if (os) return os;

  os = navigatorIsAvailable
    ? (navigator.userAgent.match(/(Windows|Macintosh)/)?.[0] as
        | 'Windows'
        | 'Macintosh'
        | undefined) || 'Other'
    : '';
  return os;
};

const useOS = () => {
  const [operatingSystem, setOperatingSystem] = useState(getOperatingSystem);

  // For SSR
  useEffect(() => {
    if (!operatingSystem) {
      setOperatingSystem(getOperatingSystem());
    }
  }, []);

  return {
    windows: operatingSystem === 'Windows',
    macintosh: operatingSystem === 'Macintosh',
    name: operatingSystem
  };
};

export default useOS;
